module.exports = __webpack_public_path__ + "img/720x1080.2c5e45f5.svg";